// extracted by mini-css-extract-plugin
export default {"lmsWrap":"acotrs_lmsWrapQZp86","bodyWrap":"acotrs_bodyWrapCL0Aq","header":"acotrs_headerqDDI3","lmsBody":"acotrs_lmsBody_YfjA"};